/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Phase_EmbeddingInputs */



/**
* | output |
* | --- |
* | "Queuing embeddings..." |
*
* @param {Sync_Phase_EmbeddingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_embedding = /** @type {((inputs?: Sync_Phase_EmbeddingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_EmbeddingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungen werden geplant...")
	return /** @type {LocalizedString} */ ("Queuing embeddings...")
});